import React, { Component } from "react"
import { inject, observer } from "mobx-react"

import LabeledSimpleInput from "~/components/Form/LabeledSimpleInput"
import NotchedField from "~/components/parking/_design/NotchedField"

const INPUT_FIELD_KEY = "email"

@inject((all) => ({
  user: all.store.auth.user,
}))
@observer
class Email extends Component {
  handleChange = (event) => {
    const rawValue = event.target.value
    const value = rawValue
      .toLowerCase()
      .trim()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")

    this.props.user.changeKey("username", value)
    this.props.user.setEmail(value)
  }

  render() {
    const { disabled, user, notched } = this.props
    const errorMessage = user.validateDisplayMessage(INPUT_FIELD_KEY)

    if (notched) {
      return (
        <NotchedField
          id="email"
          name="email"
          label="Email"
          placeholder="john@appwinit.com"
          value={user[INPUT_FIELD_KEY]}
          onChange={this.handleChange}
          error={errorMessage}
          disabled={disabled}
        />
      )
    }

    return (
      <LabeledSimpleInput
        id="email"
        name="email"
        label="Email"
        placeholder="john@appwinit.com"
        value={user[INPUT_FIELD_KEY]}
        onChange={this.handleChange}
        error={errorMessage}
        disabled={disabled}
      />
    )
  }
}

export default Email
